import i18next from 'i18next';
import { useTranslation as usei18nextTranslation } from 'react-i18next';

const NAMESPACE = 'FORM_INPUTS';

i18next.addResources('es', NAMESPACE, {
  COMPRESS_IMAGE_ERROR: 'Error al comprimir la imágen',
  UPLOAD_LIMIT_MULTIMEDIA_one: 'Puedes adjuntar como máximo {{count}} archivo',
  UPLOAD_LIMIT_MULTIMEDIA_other:
    'Puedes adjuntar como máximo {{count}} archivos',
  UPLOAD_LIMIT_FILES_one: 'Puedes adjuntar como máximo {{count}} archivo',
  UPLOAD_LIMIT_FILES_other: 'Puedes adjuntar como máximo {{count}} archivos',
  NOT_SUPPORT_MOV_EXTENSION:
    'Lo sentimos pero no soportamos la extesión .mov para videos',
  SHOW_HIDE_BUTTON: 'Mostrar u ocultar la contraseña',
  CHARACTERS_COUNTER: '{{count}}/{{max}}',
  ICONS: 'Iconos',
  EMOJIS: 'Emojis',
  FILE_TOO_LARGE: 'El peso máximo de la portada es de 5MB',
  REPLACE_IMAGE: 'Reemplazar portada',
  REMOVE_IMAGE: 'Quitar portada',
  DRAG_COVER_PICTURE: 'Arrastra la foto de portada aquí',
  OR: 'o',
  SELECT: 'selecciona',
  FROM_YOUR_PC: 'desde tu PC',
  EDIT_COVERPICTURE: 'Edita la foto de portada',
  RECOMMENDED: 'Recomendado: {{width}}x{{height}}px',
  INVALID_CHARACTERS: 'El campo contiene caracteres inválidos',
});

i18next.addResources('en', NAMESPACE, {
  COMPRESS_IMAGE_ERROR: 'Error compressing image',
  UPLOAD_LIMIT_MULTIMEDIA_one: 'You can upload a maximum of {{count}} file',
  UPLOAD_LIMIT_MULTIMEDIA_other: 'You can upload a maximum of {{count}} files',
  UPLOAD_LIMIT_FILES_one: 'You can upload a maximum of {{count}} files',
  UPLOAD_LIMIT_FILES_other: 'You can upload a maximum of {{count}} file',
  NOT_SUPPORT_MOV_EXTENSION:
    'Sorry but we do not support the .mov extension for videos',
  SHOW_HIDE_BUTTON: 'Show or hide password',
  CHARACTERS_COUNTER: '{{count}}/{{max}}',
  ICONS: 'Icons',
  EMOJIS: 'Emojis',
  FILE_TOO_LARGE: 'The maximum allowed size for the cover picture is 5MB',
  REPLACE_IMAGE: 'Replace portrait',
  REMOVE_IMAGE: 'Remove portrait',
  DRAG_COVER_PICTURE: 'Drag cover picture here',
  OR: 'or',
  SELECT: 'select',
  FROM_YOUR_PC: 'from your PC',
  EDIT_COVERPICTURE: 'Edit cover picture',
  RECOMMENDED: 'Recommended: {{width}}x{{height}}px',
  INVALID_CHARACTERS: 'Input contains invalid characters',
});

i18next.addResources('pt', NAMESPACE, {
  COMPRESS_IMAGE_ERROR: 'Erro ao compactar a imagem',
  UPLOAD_LIMIT_MULTIMEDIA_one: 'Você pode enviar no máximo {{count}} arquivo',
  UPLOAD_LIMIT_MULTIMEDIA_other:
    'Você pode enviar no máximo {{count}} arquivos',
  UPLOAD_LIMIT_FILES_one: 'Você pode enviar no máximo {{count}} arquivo',
  UPLOAD_LIMIT_FILES_other: 'Você pode enviar no máximo {{count}} arquivos',
  NOT_SUPPORT_MOV_EXTENSION:
    'Lamentamos, mas não suportamos a extensão .mov para vídeos',
  SHOW_HIDE_BUTTON: 'Mostrar ou ocultar a senha',
  CHARACTERS_COUNTER: '{{count}}/{{max}}',
  ICONS: 'Ícones',
  EMOJIS: 'Emojis',
  FILE_TOO_LARGE: 'O peso máximo da capa é de 5MB',
  REPLACE_IMAGE: 'Substituir capa',
  REMOVE_IMAGE: 'Remover capa',
  DRAG_COVER_PICTURE: 'Arraste a foto da capa aqui',
  OR: 'ou',
  SELECT: 'selecione',
  FROM_YOUR_PC: 'do seu PC',
  EDIT_COVERPICTURE: 'Edite a foto da capa',
  RECOMMENDED: 'Recomendado: {{width}}x{{height}}px',
  INVALID_CHARACTERS: 'A entrada contém caracteres inválidos',
});

export const useTranslation = () =>
  usei18nextTranslation([NAMESPACE, 'GENERAL']);
